<template>
  <div>
    <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
      <v-dialog v-model="addSoftPhoneDialog" persistent>
        <add-softphone-existing
          ref="addSoftphone"
          :account="selectedID"
          :customer="selectedCustomer"
          :services="selectedCustomerServices"
          @close="closeFromService()"
        ></add-softphone-existing>
      </v-dialog>
      <div style="padding-top: 10px">
        <v-layout row>
          <v-flex xs4>
            <vonex-text
              ref="Search"
              v-model="SearchText"
              name="Search"
              label="Search"
              append-icon="search"
              :options="fieldConditions"
            ></vonex-text>
            <!-- <v-text-field
            name="Search"
            label="Search"
            v-model="SearchText"
            append-icon="search"
          ></v-text-field> -->
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs4 v-if="allFlags.SOG5376" v-show="showDealerDropdown()">
            <v-combobox
              v-model="selectedDealerMember"
              label="Search a dealer"
              name="Selected Dealer"
              :items="dealers"
              :item-text="dealerText"
              clearable
              @click:clear="clearSelectedDealer"
              @change="updateCustomerTable"
            ></v-combobox>
          </v-flex>
        </v-layout>
      </div>
      <div>
        <v-data-table
          :headers="headers"
          :loading="loading"
          :items="
            selectedDealerMember
              ? dealerMemberCustomers(selectedDealerMember)
              : filteredRows
          "
          :pagination.sync="pagination"
          :total-items="totalItems"
        >
          <template slot="items" slot-scope="props">
            <td>
              <v-btn
                flat
                icon
                color="secondary"
                @click="NavigateToOrder(props.item.customerID, props.item.dealerID)"
                :disabled="isCreating"
              >
                <v-icon>note_add</v-icon>
              </v-btn>
            </td>
            <td class="text-md-right">{{ props.item.ubAccountNo }}</td>
            <td class="text-md-justify">{{ props.item.firstName }}</td>
            <td class="text-md-right">{{ props.item.surname }}</td>
            <td class="text-md-right">
              {{
                props.item.custType == 'R'
                  ? 'Residential'
                  : props.item.company
                  ? props.item.company
                  : props.item.companyDetails
                  ? props.item.companyDetails.companyName
                  : ''
              }}
            </td>
            <td class="text-md-right">{{ props.item.dealerID }}</td>
            <td class="text-md-right">{{ props.item.dealerName }}</td>
          </template>
        </v-data-table>
      </div>
    </ValidationObserver>
    <v-dialog v-model="isCreating" persistent width="200">
      <v-card class="py-2">
        <v-card-text class="text-xs-center">
          <v-progress-circular
            :size="50"
            indeterminate
            color="info"
          ></v-progress-circular>
          <div class="pt-3">Creating {{ isQuote ? 'Quote' : 'Order' }}</div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions, createNamespacedHelpers } from 'vuex';
import AddSoftphoneExisting from '@/components/add-softphone-existing';
const { mapState: mapOrderState } = createNamespacedHelpers(`orders`);
const {
  mapActions: mapOrderActions,
  mapMutations: mapOrderMutations,
  mapGetters: mapOrderGetters,
} = createNamespacedHelpers(`orders`);
const { mapActions: mapIPVoiceActions } =
  createNamespacedHelpers(`orders/ipVoice`);
const { mapMutations: mapCustomerMutations, mapActions: mapCustomerActions } =
  createNamespacedHelpers(`orders/customer`);
const { mapGetters: mapFeatureFlagGetters } =
  createNamespacedHelpers(`orders/featureFlag`);
import Utils from '@/mixins/utils.mixin';
import { DirectDebit } from '../models/DirectDebit';

export default {
  mixins: [Utils],
  props: {
    customerData: { type: Array, required: true },
    orderType: { type: Number, required: true },
    loading: { type: Boolean, required: false },
    totalItems: { type: Number, required: false },
  },
  computed: {
    ...mapOrderState(['rows']),
    ...mapOrderGetters([
      'message',
      'company',
      'customer',
      'dealer',
      'isResidential',
      'isSoftPhone',
      'isQuote',
      'isDirectSales',
    ]),
    ...mapFeatureFlagGetters(['allFlags']),
    filteredRows: function () {
      if (this.isDirectSales) return this.customerData;
      return this.customerData.filter(this.isValid);
    },
    companyName: function (item) {
      return item === null ? '' : item.companyName;
    },
  },
  components: {
    AddSoftphoneExisting,
  },
  data() {
    return {
      SearchText: null,
      addSoftPhoneDialog: false,
      propCustomerData: [],
      selectedID: 0,
      selectedCustomer: {},
      selectedCustomerServices: [],
      dealers: [],
      selectedDealerMember: null,
      pagination: {
        rowsPerPage: 10,
      },
      headers: [
        {
          text: 'New Order',
          align: 'left',
          sortable: false,
          value: 'true',
        },
        {
          text: 'Vonex Account no.',
          align: 'right',
          sortable: true,
          value: 'ubAccountNo',
        },
        {
          text: 'First Name',
          align: 'left',
          sortable: true,
          value: 'firstName',
        },
        {
          text: 'Surname',
          align: 'right',
          sortable: true,
          value: 'surname',
        },
        {
          text: 'Company Name',
          align: 'right',
          sortable: true,
          value: 'true',
        },
        {
          text: 'Dealer ID',
          align: 'right',
          sortable: true,
          value: 'true',
        },
        {
          text: 'Dealer Name',
          align: 'right',
          sortable: true,
          value: 'true',
        },
      ],
      directDebit: new DirectDebit(),
      isCreating: false,
    };
  },
  methods: {
    ...mapOrderActions([
      'addOrder',
      'getOrder',
      'resetOrder',
      'listOrders',
      'removeOrder',
      'updateDirectDebit',
      'getDirectDebit',
    ]),

    ...mapOrderMutations(['setResidential', 'setExistingCust']),
    ...mapIPVoiceActions(['setMessage', 'getServices']),
    ...mapCustomerMutations(['setDealerCustomers']),
    ...mapCustomerActions(['updateCustomer']),
    ...mapActions('impersonate', [
      'toggleViewBar',
      'getCurrentDealerCustomers',
      'processImpersonation',
      'getDealerMembers',
      'revokeImpersonation',
      'showLoading',
      'hideLoading',
    ]),
    dealerText(val) {
      return `${val.ubDealerID} (${val.email})`;
    },
    dealerMemberCustomers(dealer) {
      if (!dealer || !dealer.ubDealerID) {
        return this.filteredRows;
      }
      return this.filteredRows.filter(
        (customer) => customer.dealerID === dealer.ubDealerID
      );
    },
    showDealerDropdown() {
      let user_email_domain = this.$auth.user.name.split('@').pop();
      if (user_email_domain == 'vonex.com.au') return true;
      return false;
    },
    updateCustomerTable() {
      let vm = this;

      const { page, rowsPerPage } = vm.pagination;
      let dealerID = vm.selectedDealerMember
        ? vm.selectedDealerMember.dealerIDno
        : 0;
      vm.$emit('updatePage', {
        dealerID: dealerID,
        pageNo: page,
        pageSize: rowsPerPage < 0 ? vm.totalItems : rowsPerPage,
        keyword: vm.SearchText,
      });
    },
    clearSelectedDealer() {
      let vm = this;
      vm.selectedDealerMember = null;
    },
    isValid: function (customer) {
      let vm = this;
      if (vm.SearchText === null) return true;

      const filters = ['ubAccountNo', 'firstName', 'surname'];
      for (var i = 0; i < filters.length; i++) {
        if (typeof customer[filters[i]] == 'undefined') return true;
        if (typeof customer[filters[i]] == 'string') {
          if (
            customer[filters[i]] && customer[filters[i]]
              .toUpperCase()
              .includes(vm.SearchText.toUpperCase())
          )
            return true;
        } else {
          if (
            customer[filters[i]] && customer[filters[i]]
              .toString()
              .includes(vm.SearchText.toUpperCase())
          )
            return true;
        }
      }

      /*
          if (
            customer.companyDetails !== null &&
            customer.companyDetails.companyName !== null
          ) {
            if (
              customer.companyDetails.companyName
                .toUpperCase()
                .includes(vm.SearchText.toUpperCase())
            )
              return true;
          }
          */

      if (typeof customer.companyDetails != 'undefined') {
        if (
          customer.companyDetails !== null &&
          customer.companyDetails.companyName !== null
        ) {
          if (
            customer.companyDetails.companyName
              .toUpperCase()
              .includes(vm.SearchText.toUpperCase())
          )
            return true;
        }
      }

      return false;
    },
    NavigateToOrder: function (custID, cust_dealerID) {
      let vm = this;
      vm.isCreating = true;
      vm.dialog = false;
      vm.resetOrder()
        .then(() => {
          let cust = vm.customerData.filter((x) => x.customerID == custID)[0];

          let orderType =
            cust && cust.custType === 'R' ? 'Residential' : 'Business';

          vm.setResidential(orderType == 'Residential');
          let payload = { customerID: custID, type: vm.orderType };

          if (vm.showDealerDropdown()) {
            payload.dealerID = cust_dealerID;
          }

          if (vm.selectedDealerMember) {
            payload.dealerID = vm.selectedDealerMember.dealerIDno;
          }

          vm.setExistingCust();
          vm.addOrder(payload)
            .then((data) => {
              if (!vm.isQuote && vm.rows[0].existingCustomer) {
                vm.getDirectDebit().then(() => {
                  Object.assign(vm.directDebit, vm.rows[0].directDebit);

                  if (
                    vm.directDebit.hasDirectDebit &&
                    !vm.directDebit.payWithCreditCard &&
                    vm.directDebit.noDetailsProvided
                  ) {
                    vm.directDebit.useExisting = true;
                    vm.directDebit.noDetailsProvided = false;
                    vm.updateDirectDebit(vm.directDebit).then(() => {
                      vm.updateCustomer(vm.rows[0].customerID);
                    });
                  }
                });
              }

              switch (data.orderType) {
                case 1:
                  vm.$router.push({
                    path: 'change-address',
                  });

                  break;
                case 2:
                  //   vm.$router.push({
                  //     path: "change-lessee",
                  //   });
                  //   break;
                  // case 3:
                  vm.$router.push({
                    path: 'create-customer',
                  });
                  break;

                default:
                  if (vm.isSoftPhone) {
                    vm.selectedID = custID;
                    vm.selectedCustomer = this.filteredRows.find(
                      (s) => s.customerID === custID
                    );
                    vm.addSoftPhoneDialog = true;
                    vm.LoadServices(custID);
                  } else
                    vm.$router.push({
                      path:
                        orderType == 'Residential'
                          ? 'create-customer'
                          : 'create-company',
                    });
                  break;
              }
            })
            .catch(() => {})
            .finally(() => {
              vm.isCreating = false;
            });
        })
        .catch(() => {});
    },
    closeFromService() {
      this.addSoftPhoneDialog = false;
      this.setDealerCustomers(null);
    },
    LoadServices(custID) {
      let customer = this.filteredRows.find((s) => s.customerID === custID);

      this.getServices(customer.ubAccountNo)
        .then((data) => {
          this.$refs.addSoftphone.loading = false;
          if (
            data &&
            data.length > 0 &&
            data.some((x) => x.type.toUpperCase() == 'VOIP')
          ) {
            this.setMessage({ message: 'Data loaded!', httpStatus: 200 });
          } else {
            this.setMessage({
              message: 'no VoIP services!',
              httpStatus: 200,
            });
          }
          this.selectedCustomerServices = data.filter(
            (x) =>
              x.type === 'VoIP' &&
              !x.plan.toLowerCase().includes('softphone') &&
              !x.plan.toLowerCase().includes('hunt') &&
              !x.released
          );
          if (
            this.items &&
            !this.items.some(
              (x) =>
                x.type === 'VoIP' &&
                !x.plan.toLowerCase().includes('fax') &&
                !x.released
            )
          ) {
            this.selectAllDisable = true;
          }
        })
        .catch(() => {
          this.$refs.addSoftphone.loading = false;
        });
    },
  },
  watch: {
    pagination: {
      handler() {
        let vm = this;
        // if (vm.isDirectSales) {
        const { page, rowsPerPage } = vm.pagination;
        vm.$emit('updatePage', {
          dealerID: vm.selectedDealerMember
            ? vm.selectedDealerMember.dealerIDno
            : 0,
          pageNo: page,
          pageSize: rowsPerPage < 0 ? vm.totalItems : rowsPerPage,
          keyword: vm.SearchText,
        });
        // }
      },
      deep: true,
    },
    SearchText(val) {
      let vm = this;
      if (val !== null) {
        if (val.length > 3 || val == '')
          this.$emit('updatePage', {
            dealerID: vm.selectedDealerMember
              ? vm.selectedDealerMember.dealerIDno
              : 0,
            pageNo: vm.pagination.page,
            pageSize:
              vm.pagination.rowsPerPage < 0
                ? vm.totalItems
                : vm.pagination.rowsPerPage,
            keyword: val,
          });
      }
    },
  },
  mounted() {
    this.getDealerMembers()
      .then((data) => (this.dealers = data.filter((x) => x.dealerIDno !== 2097)))
      .catch((err) => {
        if (!err.message.includes(401)) {
          this.$root.$alert.invoke(`${err.name}: ${err.message}`, 'error');
        }
      });
  },
};
</script>
<style></style>
